import React from 'react';
import PropTypes from 'prop-types';

import { FormControlLabel, FormControl } from 'material-ui/Form';
import { Switch } from 'material-ui';

// import { Field } from 'redux-form';
// import * as regexp from 'libs/validation';

import { ReduxFormField, ReduxFormFieldCheckPopup } from 'components';

const renderField = ({ input, meta, checkType, validate, warn, label, className, ...rest }) => {
  if (label) {
    return (
      <FormControlLabel
        className={className}
        control={
          <Switch
            classes={{
              checked: 'checked'
            }}
            className="switch"
            // input 전체를 전달하지 않고 아래 onChange 와 같이 필요한 이벤트 핸들러만 사용한다.
            // 이렇게 하면 불필요한 blur 이벤트 등이 발생하지 않아 처리가 간소해 지고
            // onChange 이벤트 내에서 setState 이용 시 pending 이 발생하지 않게 된다.
            // {...input}
            name={input.name}
            // redux-form 저장소에 값이 정상적으로 들어가도록 맞춤
            // switch, checkbox 의 경우 값을 문자 '1', '0' 으로 통일
            // 또한 이렇게 하지 않는 경우 value 값에 string, boolean 이 교차로 들어가게 되어 맞춰야 하는 번거로움이 있음
            onChange={(e, checked) => {
              input.onChange(checked ? '1' : '0');
            }}
            // onBlur 가 필요한 경우
            onBlur={e => {
              input.onBlur();
            }}
            checked={Number(input.value) === 1 ? true : false}
            {...rest}
          />
        }
        label={label}>
        <ReduxFormFieldCheckPopup checkType={checkType} {...meta} />
      </FormControlLabel>
    );
  } else {
    return (
      <FormControl className={className}>
        <Switch
          classes={{
            checked: 'checked'
          }}
          className="switch"
          // input 전체를 전달하지 않고 아래 onChange 와 같이 필요한 이벤트 핸들러만 사용한다.
          // 이렇게 하면 불필요한 blur 이벤트 등이 발생하지 않아 처리가 간소해 지고
          // onChange 이벤트 내에서 setState 이용 시 pending 이 발생하지 않게 된다.
          // {...input}
          name={input.name}
          // redux-form 저장소에 값이 정상적으로 들어가도록 맞춤
          // switch, checkbox 의 경우 값을 문자 '1', '0' 으로 통일
          // 또한 이렇게 하지 않는 경우 value 값에 string, boolean 이 교차로 들어가게 되어 맞춰야 하는 번거로움이 있음
          onChange={(e, checked) => {
            input.onChange(checked ? '1' : '0');
          }}
          // onBlur 가 필요한 경우
          onBlur={e => {
            input.onBlur();
          }}
          checked={Number(input.value) === 1 ? true : false}
          {...rest}
        />
        <ReduxFormFieldCheckPopup checkType={checkType} {...meta} />
      </FormControl>
    );
  }
};

const ReduxFormMaterialSwitch = ({ ...rest }) => {
  return <ReduxFormField component={renderField} {...rest} />;
};

ReduxFormMaterialSwitch.propTypes = {
  checkType: PropTypes.number
};
ReduxFormMaterialSwitch.defaultProps = {
  checkType: 99
};

export default ReduxFormMaterialSwitch;



// WEBPACK FOOTER //
// ./src/script/components/reduxForm/ReduxFormMaterialSwitch.js